import React, { Component } from 'react';
import propTypes from 'prop-types';

import calendarImg from '../../../assets/icons/black/calendar.png';
import phoneImg from '../../../assets/icons/black/phone.png';


export default class ModuleOffers extends Component {
  constructor(props) {
    super();
    this.state = {
      offers: {
        options: [],
        selected: [],
        actions: [],
      },
    }
  }


  componentDidMount() {
    let offers = {};
    let actions = [];
    if (this.props.currentRecord['Offer Option']) {
      offers.options = JSON.parse('[' + this.props.currentRecord['Offer Option'].replace(/,,/g, ",") + ']');
    }
    if (this.props.currentRecord['Offer Selected']) {
      offers.selected = JSON.parse('[' + this.props.currentRecord['Offer Selected'].replace(/,,/g, ",") + ']');
    }
    if (this.props.currentRecord['Offer Action']) {
      console.log(this.props.currentRecord['Offer Action'].replace(/,,/g, ",").replace(/,\s*$/, ""));
      actions = JSON.parse('[' + this.props.currentRecord['Offer Action'].replace(/,,/g, ",").replace(/,\s*$/, "") + ']');

      // offers.actions

      console.log(actions);

      let possibleActions = [];

      offers.actions = [];
      for (var i in actions) {
        if (actions[i].action) {
          if (actions[i].action === 'Accepted') {
            offers.actions.push(actions[i]);
          } else {
            possibleActions.push(actions[i])
          }
        } else { //is rejection
          actions[i].action = 'Rejected';
          offers.actions.push(actions[i]);
        }
      }

      possibleActions = possibleActions.filter((v,i,a)=>a.findIndex(v2=>(v2.company===v.company))===i)

      for (var u in possibleActions) {
        if (offers.actions.filter(e => e.company === possibleActions[u].company).length) {
        } else {
          offers.actions.push(possibleActions[u])
        }
      }

      offers.actions.sort(function(o){ return new Date( o.date ) });
    }

    this.setState({
      offers: offers
    })
  }
  // Render
  // ----------------------------------------------------
  render() {
    let offers = this.state.offers;

    if (offers.options && offers.options.length && offers.actions && offers.actions.length) {
      return (
        <div className={offers.options.length > 0 ? "ModuleCard" : "ModuleCard isHidden"}>
          <div className="inner">

            <div className="inputBlock inputBlock--full">
              <h3>Offers</h3>
              <p>Coverage Possibility - <strong>{offers.options.length}</strong></p>
              <p>Selected for Offer - <strong>{offers.actions.length}</strong></p>
              <hr />

              {offers.actions.length > 0 ? offers.actions.map((e, i) => {
                return (
                  <div className={"actionBox " + e.action}>
                    <p>{e.date}</p>
                    <h5>{e.company} <strong>(${e.amount.replace('$', '').replace('.00', '')})</strong></h5>

                    <p className={e.reason ? "reasoning" : 'isHidden'}>{e.reason}</p>
                  </div>
                );
              }) : ''}
            </div>

          </div>
        </div>
      );
    } else {
      return (
        <div className="ModuleCard isHidden"></div>
      )
    }
  }
}

ModuleOffers.propTypes ={
  currentRecord: propTypes.object,
}



// WEBPACK FOOTER //
// ./src/Franchisees/Records/Modules/ModuleOffers.js